import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { homeHeroSlides } from '@/mocks/home';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = homeHeroSlides.length;

  const goTo = useCallback((index: number) => {
    setCurrent((index + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(timer);
  }, [total]);

  const slide = homeHeroSlides[current];

  return (
    <section className="relative h-[520px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={slide.image}
          alt={slide.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="max-w-2xl">
            {slide.badge && (
              <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold text-white ${slide.badgeColor} mb-4`}>
                {slide.badge}
              </span>
            )}
            <h1 className="text-3xl md:text-5xl font-heading text-white mb-4 leading-tight">
              {slide.title}
            </h1>
            <p className="text-white/80 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
              {slide.desc}
            </p>
            <Link
              to={slide.link}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
            >
              立即阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {homeHeroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current ? 'bg-white w-6' : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`切换到第${i + 1}张`}
          />
        ))}
      </div>

      <button
        onClick={() => goTo(current - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-all z-10 cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={() => goTo(current + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-all z-10 cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </section>
  );
}